export default "__VITE_ASSET__JB$eeexI__"